import { Minus, Plus } from "lucide-react";
import { Link } from "react-router-dom";
import { useCartActions } from "../hooks/useCartActions";
import { getProductPdpUrl } from "../../../../utils/url.utils";
import { formatDiscount, formatPrice } from "../../../../utils/price.utils";

const CartItem = ({ item }) => {
    const {
        updatingId,
        handleRemoveItem,
        handleUpdateQty,
        handleMoveToWishlist,
        pinset,
    } = useCartActions();

    return (
        <div className="cart-item">
            <div className="item-image">
                <Link
                    to={getProductPdpUrl(item.product?.action_url, item.product?.sku)}
                    target="_blank"
                >
                    <img
                        className="img-cart-page pointer-crusser"
                        src={item.product?.media}
                        alt={item.product?.name}
                        loading="lazy"
                    />
                </Link>
            </div>

            <div className="item-details">
                <h4 className="item-title pointer-crusser">
                    <Link
                        to={getProductPdpUrl(item.product?.action_url, item.product?.sku)}
                        target="_blank"
                    >
                        <span className="product-name-span">
                            {item.product?.name}
                        </span>
                    </Link>
                </h4>

                <span className="price_details_cart">
                    {formatPrice(item.product?.selling_price)}
                    {item.product.discount > 0 && (
                        <span className="sub-1">
                            <del>{formatPrice(item.product?.mrp)}</del>
                            &nbsp;
                            <span className="dis-sub">
                                {formatDiscount(item.product?.discount)}
                            </span>
                        </span>
                    )}
                </span>

                <p>Color : <span>{item.product?.color}</span></p>
                <p>TAT Delivery : <span>{pinset?.delivery_tat}</span></p>

                <div className="root_qtn_cart">
                    <div className="subroot_sector_qtn">
                        <p>Quantity:</p>

                        <div className="quantity">
                            <button
                                className="tracker-btn"
                                onClick={() =>
                                    handleUpdateQty(item.product_id, item.cart_qty - 1)
                                }
                                disabled={updatingId === item.product_id}
                            >
                                <Minus size={20} strokeWidth={1.25} />
                            </button>

                            <span className="qtn_track">{item.cart_qty}</span>

                            <button
                                className="tracker-btn"
                                onClick={() =>
                                    handleUpdateQty(item.product_id, item.cart_qty + 1)
                                }
                                disabled={updatingId === item.product_id}
                            >
                                <Plus size={20} strokeWidth={1.25} />
                            </button>
                        </div>
                    </div>

                    <div className="actions">
                        <span onClick={() => handleRemoveItem(item.id)}>Remove</span>
                        <span onClick={() => handleMoveToWishlist(item)}>
                            Move to Wishlist
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CartItem;